import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "absolute overflow-hidden w-full h-screen" }
const _hoisted_2 = { class: "z-30" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "custom-background absolute w-full h-1/2" }, null, -1)
const _hoisted_4 = { class: "m-auto z-10 w-screen" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  alt: "",
  src: "/full-logo-white.png",
  width: "200",
  height: "50",
  class: "mx-auto mb-6"
}, null, -1)
const _hoisted_6 = { class: "block md:flex text-center justify-between" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "custom-background absolute w-full h-1/2 bottom-0" }, null, -1)
const _hoisted_8 = { class: "m-auto z-10 w-screen" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  width: "200",
  height: "50",
  src: "/logo.svg",
  alt: "TecnoPay",
  class: "mx-auto mb-6"
}, null, -1)
const _hoisted_10 = { class: "flex justify-center" }
const _hoisted_11 = { class: "w-full flex" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "text-xs text-center w-full" }, " Foi enviado um código de validação para o seu e-mail. ", -1)
const _hoisted_13 = { class: "flex justify-center" }
const _hoisted_14 = { class: "m-1 text-sm" }
const _hoisted_15 = { class: "flex justify-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "m-auto z-10 w-screen" }, [
  /*#__PURE__*/_createElementVNode("embed", {
    width: "150",
    height: "150",
    src: "/colorful-loading.gif",
    class: "mx-auto mb-6"
  })
], -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "m-auto z-10 w-screen" }, [
  /*#__PURE__*/_createElementVNode("embed", {
    width: "150",
    height: "150",
    src: "/colorful-loading.gif",
    class: "mx-auto mb-6"
  })
], -1)
const _hoisted_19 = [
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_Password = _resolveComponent("Password")!
  const _component_PrimaryButton = _resolveComponent("PrimaryButton")!
  const _component_Link = _resolveComponent("Link")!
  const _component_Form = _resolveComponent("Form")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Validator = _resolveComponent("Validator")!
  const _component_Toast = _resolveComponent("Toast")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.state), 1),
    _createElementVNode("div", {
      id: "auth",
      class: _normalizeClass(["absolute flex h-screen w-screen", _ctx.state == 'authenticating' ? 'auth-recovery' : _ctx.state == 'loading' ? 'auth-load' : ''])
    }, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_Card, {
          class: "pt-8 px-6 mx-auto",
          width: "w-11/12 md:w-1/2 lg:w-1/3",
          title: "Área administrativa",
          orientation: "flex-col"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Form, {
              onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.authenticate()), ["prevent"])),
              class: "divide-transparent text-left"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Input, {
                  label: "E-mail",
                  incorrectMessage: _ctx.userMessage,
                  isIncorrect: _ctx.userMessage != '',
                  class: "p-0",
                  modelValue: _ctx.user,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.user) = $event))
                }, null, 8, ["incorrectMessage", "isIncorrect", "modelValue"]),
                _createVNode(_component_Password, {
                  label: "Senha",
                  incorrectMessage: _ctx.passwordMessage,
                  isIncorrect: _ctx.passwordMessage != '',
                  labelClass: "text-left",
                  class: "p-0",
                  modelValue: _ctx.password,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event))
                }, null, 8, ["incorrectMessage", "isIncorrect", "modelValue"]),
                _createVNode(_component_PrimaryButton, {
                  label: "Enviar",
                  class: "p-0 w-full",
                  width: "w-full",
                  type: "submit"
                }),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_Link, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.recover(false))),
                    class: "pb-2",
                    label: "Esqueci minha senha"
                  }),
                  _createVNode(_component_Link, {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.recover(true))),
                    label: "Primeiro acesso"
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ], 2),
    _createElementVNode("div", {
      id: "recovery",
      class: _normalizeClass(["absolute flex h-screen w-screen", _ctx.state == 'recovering' ? 'recovery-active' : _ctx.state == 'recovery-loading' ? 'recovery-load' : ''])
    }, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_Card, {
          class: "pt-8 px-6 mx-auto",
          width: "w-11/12 md:w-1/2 lg:w-1/3",
          title: _ctx.isNew ? 'Primeiro Acesso' : 'Recuperar senha',
          orientation: "flex-col"
        }, {
          default: _withCtx(() => [
            (_ctx.recoverStatus == 'identifying')
              ? (_openBlock(), _createBlock(_component_Form, {
                  key: 0,
                  onSubmit: _cache[9] || (_cache[9] = _withModifiers(() => _ctx.identify(_ctx.isNew), ["prevent"])),
                  class: "divide-transparent text-left"
                }, {
                  default: _withCtx(() => [
                    (_ctx.isNew)
                      ? (_openBlock(), _createBlock(_component_Input, {
                          key: 0,
                          label: "CNPJ",
                          mask: "##.###.###/####-##",
                          incorrectMessage: _ctx.cnpjMessage,
                          isIncorrect: _ctx.cnpjMessage != '',
                          class: "p-0",
                          modelValue: _ctx.cnpj,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.cnpj) = $event))
                        }, null, 8, ["incorrectMessage", "isIncorrect", "modelValue"]))
                      : _createCommentVNode("", true),
                    (_ctx.isNew)
                      ? (_openBlock(), _createBlock(_component_Input, {
                          key: 1,
                          label: "E-mail",
                          incorrectMessage: _ctx.emailMessage,
                          isIncorrect: _ctx.emailMessage != '',
                          class: "p-0",
                          modelValue: _ctx.email,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.email) = $event))
                        }, null, 8, ["incorrectMessage", "isIncorrect", "modelValue"]))
                      : (_openBlock(), _createBlock(_component_Input, {
                          key: 2,
                          label: "E-mail",
                          incorrectMessage: _ctx.userMessage,
                          isIncorrect: _ctx.userMessage != '',
                          class: "p-0",
                          modelValue: _ctx.user,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.user) = $event))
                        }, null, 8, ["incorrectMessage", "isIncorrect", "modelValue"])),
                    _createVNode(_component_PrimaryButton, {
                      label: "Enviar",
                      class: "p-0",
                      width: "w-full",
                      type: "submit"
                    }),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_Link, {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.back())),
                        label: "Voltar para o login"
                      })
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.recoverStatus == 'validating')
              ? (_openBlock(), _createBlock(_component_Form, {
                  key: 1,
                  class: "divide-transparent text-left"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _createVNode(_component_Validator, {
                        class: "m-auto",
                        onValidate: _ctx.validate
                      }, null, 8, ["onValidate"])
                    ]),
                    _hoisted_12,
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_Link, {
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.back())),
                        label: "Voltar para o login"
                      })
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.recoverStatus == 'redefining')
              ? (_openBlock(), _createBlock(_component_Form, {
                  key: 2,
                  onSubmit: _cache[14] || (_cache[14] = _withModifiers(() => _ctx.redefine(), ["prevent"])),
                  class: "divide-transparent text-left"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_14, [
                      _createTextVNode(" A senha deve conter pelo menos "),
                      _createElementVNode("b", {
                        class: _normalizeClass(!_ctx.hasMinLength ? 'text-red-500' : '')
                      }, "8 caracteres", 2),
                      _createTextVNode(", devendo conter: "),
                      _createElementVNode("b", {
                        class: _normalizeClass(!_ctx.hasUppercase ? 'text-red-500' : '')
                      }, "1 letra maiúscula", 2),
                      _createTextVNode(", "),
                      _createElementVNode("b", {
                        class: _normalizeClass(!_ctx.hasLowercase ? 'text-red-500' : '')
                      }, "1 letra minúscula", 2),
                      _createTextVNode(", "),
                      _createElementVNode("b", {
                        class: _normalizeClass(!_ctx.hasNumber ? 'text-red-500' : '')
                      }, "1 número", 2),
                      _createTextVNode(", "),
                      _createElementVNode("b", {
                        class: _normalizeClass(!_ctx.hasSpecialCharacter ? 'text-red-500' : '')
                      }, "1 caractere especial", 2),
                      _createTextVNode(", ")
                    ]),
                    _createVNode(_component_Password, {
                      label: "Informe a senha",
                      incorrectMessage: _ctx.newPasswordMessage,
                      isIncorrect: _ctx.newPasswordMessage != '',
                      class: "p-0",
                      modelValue: _ctx.newPassword,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.newPassword) = $event))
                    }, null, 8, ["incorrectMessage", "isIncorrect", "modelValue"]),
                    _createVNode(_component_Password, {
                      label: "Repita a senha",
                      incorrectMessage: _ctx.repeatNewPasswordMessage,
                      isIncorrect: _ctx.repeatNewPasswordMessage != '',
                      labelClass: "text-left",
                      class: "p-0",
                      modelValue: _ctx.repeatNewPassword,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.repeatNewPassword) = $event))
                    }, null, 8, ["incorrectMessage", "isIncorrect", "modelValue"]),
                    _createVNode(_component_PrimaryButton, {
                      label: "Enviar",
                      class: "p-0",
                      width: "w-full",
                      type: "submit"
                    }),
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_Link, {
                        onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.back())),
                        label: "Voltar para o login"
                      })
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["title"])
      ])
    ], 2),
    _createElementVNode("div", {
      id: "loading",
      class: _normalizeClass(["absolute flex h-screen w-screen", _ctx.state == 'loading' ? 'loading-active' : ''])
    }, _hoisted_17, 2),
    _createElementVNode("div", {
      id: "recovery-loading",
      class: _normalizeClass(["absolute flex h-screen w-screen", _ctx.state == 'recovery-loading' ? 'recovery-loading-active' : ''])
    }, _hoisted_19, 2),
    _createVNode(_component_Toast, {
      label: _ctx.message,
      success: _ctx.success,
      hidden: _ctx.hidden,
      onHide: _ctx.hide
    }, null, 8, ["label", "success", "hidden", "onHide"])
  ]))
}